'use client';

import RegisterHeader from '@/components/ui/buttons/register-header';
import LoginHeader from '@/components/ui/buttons/login-header';
import UserIcon from '@/components/ui/icons/user-icon';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import AuthModal from '@/components/ui/modals/auth-modal';
import { useSession } from 'next-auth/react';
import NextLink from '@/components/next-link';

const Account = () => {
  const [auth, setAuth] = useState(false);
  const t = useTranslations('common');
  const { data: session } = useSession();

  return (
    <>
      <div className='hidden items-center gap-2.5 lg:flex'>
        <span className='flex size-10 items-center justify-center rounded-full bg-[#F6F6F7]'>
          <UserIcon />
        </span>
        <div className='flex flex-col'>
          <span className='text-xs text-[#74787C] uppercase'>
            {t('My Account')}
          </span>
          {session && (
            <NextLink
              href='/user'
              prefetch={false}
              className='flex items-center gap-1'
            >
              <span className='text-xs font-semibold uppercase hover:underline'>
                {session?.user?.firstname} {session?.user?.lastname}
              </span>
            </NextLink>
          )}
          {!session && (
            <div className='flex items-center gap-1'>
              <LoginHeader {...{ setAuth, t }} />
              <span> | </span>
              <RegisterHeader {...{ setAuth, t }} />
            </div>
          )}
        </div>
      </div>
      <AuthModal auth={auth} setAuth={setAuth} />
    </>
  );
};

export default Account;
